import FloatRank from "../../../packs_helper/scripts/FloatRank.js";
import SelectBox from "../../../packs_helper/scripts/SelectBox.js";

FloatRank();
SelectBox();

// const filterTop = document.querySelector('.filter-top');
// filterTop.addEventListener('submit', function(e){
// 	const formData = new FormData(e.target);
// }, false);

const autoSendFilters = document.querySelectorAll('#online, #confirmed, #order, #purchase, #video, [rel="filter-selection"]');
autoSendFilters.forEach(function(el){
	el.addEventListener('change', function(e){
		document.body.setAttribute('data-wait-for-response', 'true')
		e.target.closest('form').submit();
	})
})

const category = document.getElementById('category');
if(category){
	category.addEventListener('change', function(e){
		redirect(`/${this.value}`);
	});
}

// Tüm dokümana event delegation yaparak hem mobil hem masaüstü versiyonlarını destekliyoruz
document.addEventListener('click', function(e){
	// Reset butonuna tıklanıp tıklanmadığını kontrol ediyoruz
	if(e.target.type === 'reset' || e.target.matches('[type="reset"]')){
		e.preventDefault(); // Default reset davranışını engelleyebiliriz
		document.body.setAttribute('data-wait-for-response', 'true')
		redirect(window.location.pathname);
	}
});

const productSkins = document.querySelectorAll('.product-skin');
productSkins.forEach(function(el){
	const picture = el.querySelector('.product-image button');
	if(picture){
		picture.addEventListener('click', function(e){
			e.preventDefault();
		})
	}
});


const filterToggler = document.getElementById('filter-toggler');
if(filterToggler){
	// const filterTopBody = filterTop.querySelector('.filter-top-body');
	filterToggler.addEventListener('click', filterChanger);
}

function filterChanger(){
	const filterTop = filterToggler.closest('.filter-top');
	if(filterTop.classList.contains('open')){
		filterTop.classList.remove('open');
	}else{
		filterTop.classList.add('open');
	}
}